export default "__VITE_ASSET__uT$crqEf__"